// extracted by mini-css-extract-plugin
module.exports = {"link":"_2Alcq","root":"_3mfy7","label":"_2EJjw"};